import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';
import { authenticatePublishingWallet } from './digitalAssetsClient';

let notifications;
export async function callNotifications(wallet, payload, { isCurrent = () => true } = {}) {
    const walletUid = await authenticatePublishingWallet(wallet, { isCurrent });
    if (!isCurrent()) throw new Error('Wallet or inbox changed. Please retry.');
    if (!notifications) notifications = httpsCallable(functions, 'notifications');
    const result = (await notifications({ ...payload, walletUid })).data;
    if (!isCurrent()) throw new Error('Wallet or inbox changed. Please retry.');
    return result;
}
